import React from 'react'
import { List as SList } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
// import { history } from '../../redux/store'
import ListItem from './list-item/list-item'
// import { setUserProducts } from '../../redux/actions/auth'
import { ProducAuth, SetProduct } from '../../services/product'

const ProductList = (props) => {
  const { productData } = useSelector((store) => ({
    productData: store.auth.productList,
  }))
  const [products] = React.useState(
    productData || JSON.parse(localStorage.getItem('products')),
  )

  const handleProduct = (item) => {
    ProducAuth(item.productName).then((data) => {
      if (data.success) {
        SetProduct(item.productName)
      }
    })
  }
  return products.map((item) => (
    <SList {...props}>
      <ListItem
        style={{ cursor: 'pointer', margin: 'auto', display: 'inline-block' }}
        imageSrc={item.imgSrc}
        title={`Spectro${`${item.productName}`.toLocaleUpperCase()}`}
        onClick={() => handleProduct(item)}
      />
    </SList>
  ))
}

export default ProductList
